"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Manage My Pain API
 * This document provide full documentation for [ManagingLife](http://managinglife.com) API # Introduction Each API call only supports POST calls, and all parameters goes to body of POST request<br> Format of each API endpoint is `https://SERVER.managinglife.com/api/vVERSION/SERVICE/METHOD`   - **SERVER** could be one of: *dev*, *preprod*, *sync*.   - **VERSION** could be one of: *1*, *3*, *4*.   - **SERVICE** e.g. *core*, *sync*, *alerts*.   - **METHOD** e.g. *generate-report*, *login-user*, *update-records*.  Any parameter that is not marked as required can be null or omitted. # Client libraries We also provide several client libraries which were auto-generated using swagger-codegen.   - [JavaScript](/codegen/javascript)   - [Java](/codegen/java)   - [PHP](/codegen/php)   - [Objective C](/codegen/objc) # Authentication <!-- ReDoc-Inject: <security-definitions> --> 
 *
 * The version of the OpenAPI document: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The CreateInstitutionParamsInstitution model module.
 * @module model/CreateInstitutionParamsInstitution
 * @version 4.0.0
 */
var CreateInstitutionParamsInstitution = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>CreateInstitutionParamsInstitution</code>.
   * @alias module:model/CreateInstitutionParamsInstitution
   */
  function CreateInstitutionParamsInstitution() {
    _classCallCheck(this, CreateInstitutionParamsInstitution);
    CreateInstitutionParamsInstitution.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(CreateInstitutionParamsInstitution, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>CreateInstitutionParamsInstitution</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CreateInstitutionParamsInstitution} obj Optional instance to populate.
     * @return {module:model/CreateInstitutionParamsInstitution} The populated <code>CreateInstitutionParamsInstitution</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new CreateInstitutionParamsInstitution();
        if (data.hasOwnProperty('name')) {
          obj['name'] = _ApiClient["default"].convertToType(data['name'], 'String');
        }
        if (data.hasOwnProperty('type')) {
          obj['type'] = _ApiClient["default"].convertToType(data['type'], 'String');
        }
        if (data.hasOwnProperty('description')) {
          obj['description'] = _ApiClient["default"].convertToType(data['description'], 'String');
        }
        if (data.hasOwnProperty('clientMax')) {
          obj['clientMax'] = _ApiClient["default"].convertToType(data['clientMax'], 'Number');
        }
        if (data.hasOwnProperty('consentText')) {
          obj['consentText'] = _ApiClient["default"].convertToType(data['consentText'], 'String');
        }
        if (data.hasOwnProperty('questionnaireAutoRequest')) {
          obj['questionnaireAutoRequest'] = _ApiClient["default"].convertToType(data['questionnaireAutoRequest'], 'Number');
        }
        if (data.hasOwnProperty('questionnaireFirstNotification')) {
          obj['questionnaireFirstNotification'] = _ApiClient["default"].convertToType(data['questionnaireFirstNotification'], 'Number');
        }
        if (data.hasOwnProperty('organization')) {
          obj['organization'] = _ApiClient["default"].convertToType(data['organization'], 'String');
        }
        if (data.hasOwnProperty('validStudyIDs')) {
          obj['validStudyIDs'] = _ApiClient["default"].convertToType(data['validStudyIDs'], 'String');
        }
        if (data.hasOwnProperty('isStudyIDValidation')) {
          obj['isStudyIDValidation'] = _ApiClient["default"].convertToType(data['isStudyIDValidation'], 'Number');
        }
        if (data.hasOwnProperty('isAll')) {
          obj['isAll'] = _ApiClient["default"].convertToType(data['isAll'], 'Number');
        }
        if (data.hasOwnProperty('isDeidentified')) {
          obj['isDeidentified'] = _ApiClient["default"].convertToType(data['isDeidentified'], 'Number');
        }
        if (data.hasOwnProperty('isEnablePro')) {
          obj['isEnablePro'] = _ApiClient["default"].convertToType(data['isEnablePro'], 'Number');
        }
        if (data.hasOwnProperty('isExclusive')) {
          obj['isExclusive'] = _ApiClient["default"].convertToType(data['isExclusive'], 'Number');
        }
        if (data.hasOwnProperty('startDate')) {
          obj['startDate'] = _ApiClient["default"].convertToType(data['startDate'], 'String');
        }
        if (data.hasOwnProperty('endDate')) {
          obj['endDate'] = _ApiClient["default"].convertToType(data['endDate'], 'String');
        }
        if (data.hasOwnProperty('routingUrls')) {
          obj['routingUrls'] = _ApiClient["default"].convertToType(data['routingUrls'], ['String']);
        }
        if (data.hasOwnProperty('joinInstitutionIfNoConsent')) {
          obj['joinInstitutionIfNoConsent'] = _ApiClient["default"].convertToType(data['joinInstitutionIfNoConsent'], 'Number');
        }
        if (data.hasOwnProperty('skipWelcomeEmail')) {
          obj['skipWelcomeEmail'] = _ApiClient["default"].convertToType(data['skipWelcomeEmail'], 'Number');
        }
        if (data.hasOwnProperty('painGuideAvailable')) {
          obj['painGuideAvailable'] = _ApiClient["default"].convertToType(data['painGuideAvailable'], 'Number');
        }
        if (data.hasOwnProperty('childInstitutionNids')) {
          obj['childInstitutionNids'] = _ApiClient["default"].convertToType(data['childInstitutionNids'], ['Number']);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CreateInstitutionParamsInstitution</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CreateInstitutionParamsInstitution</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
        throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
      }
      // ensure the json data is a string
      if (data['type'] && !(typeof data['type'] === 'string' || data['type'] instanceof String)) {
        throw new Error("Expected the field `type` to be a primitive type in the JSON string but got " + data['type']);
      }
      // ensure the json data is a string
      if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
        throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
      }
      // ensure the json data is a string
      if (data['consentText'] && !(typeof data['consentText'] === 'string' || data['consentText'] instanceof String)) {
        throw new Error("Expected the field `consentText` to be a primitive type in the JSON string but got " + data['consentText']);
      }
      // ensure the json data is a string
      if (data['organization'] && !(typeof data['organization'] === 'string' || data['organization'] instanceof String)) {
        throw new Error("Expected the field `organization` to be a primitive type in the JSON string but got " + data['organization']);
      }
      // ensure the json data is a string
      if (data['validStudyIDs'] && !(typeof data['validStudyIDs'] === 'string' || data['validStudyIDs'] instanceof String)) {
        throw new Error("Expected the field `validStudyIDs` to be a primitive type in the JSON string but got " + data['validStudyIDs']);
      }
      // ensure the json data is a string
      if (data['startDate'] && !(typeof data['startDate'] === 'string' || data['startDate'] instanceof String)) {
        throw new Error("Expected the field `startDate` to be a primitive type in the JSON string but got " + data['startDate']);
      }
      // ensure the json data is a string
      if (data['endDate'] && !(typeof data['endDate'] === 'string' || data['endDate'] instanceof String)) {
        throw new Error("Expected the field `endDate` to be a primitive type in the JSON string but got " + data['endDate']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['routingUrls'])) {
        throw new Error("Expected the field `routingUrls` to be an array in the JSON data but got " + data['routingUrls']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['childInstitutionNids'])) {
        throw new Error("Expected the field `childInstitutionNids` to be an array in the JSON data but got " + data['childInstitutionNids']);
      }
      return true;
    }
  }]);
}();
/**
 * Institution name
 * @member {String} name
 */
CreateInstitutionParamsInstitution.prototype['name'] = undefined;

/**
 * Type of the Institution
 * @member {module:model/CreateInstitutionParamsInstitution.TypeEnum} type
 */
CreateInstitutionParamsInstitution.prototype['type'] = undefined;

/**
 * Institution description
 * @member {String} description
 */
CreateInstitutionParamsInstitution.prototype['description'] = undefined;

/**
 * Maximum number of participants that can be assigned to the institution
 * @member {Number} clientMax
 */
CreateInstitutionParamsInstitution.prototype['clientMax'] = undefined;

/**
 * Consent text for the institution
 * @member {String} consentText
 */
CreateInstitutionParamsInstitution.prototype['consentText'] = undefined;

/**
 * When set to 1, a participant who joins the institution will be requested to complete all the default \"visible\" AND \"enabled\" questionnaires.  The due date will be set to the join date.
 * @member {Number} questionnaireAutoRequest
 */
CreateInstitutionParamsInstitution.prototype['questionnaireAutoRequest'] = undefined;

/**
 * When set to 1, a participant who joins the institution and has questionnaires that need to be completed (as a result of `questionnaireAutoRequest` being set to 1) will receive an email notification.
 * @member {Number} questionnaireFirstNotification
 */
CreateInstitutionParamsInstitution.prototype['questionnaireFirstNotification'] = undefined;

/**
 * Institution organization
 * @member {String} organization
 */
CreateInstitutionParamsInstitution.prototype['organization'] = undefined;

/**
 * List of all study ids that are valid for the institution (divided by comma, without space after)
 * @member {String} validStudyIDs
 */
CreateInstitutionParamsInstitution.prototype['validStudyIDs'] = undefined;

/**
 * Parameter shows whether or not server needs to perform study_id validation when new participant is being assigned to the institution
 * @member {Number} isStudyIDValidation
 */
CreateInstitutionParamsInstitution.prototype['isStudyIDValidation'] = undefined;

/**
 * If set to 1, then the institution includes ALL users in the system, other than those who are part of an \"exclusive\" institution. If not provided, then it is considered as 0 by default.
 * @member {Number} isAll
 */
CreateInstitutionParamsInstitution.prototype['isAll'] = undefined;

/**
 * If set to 1, then instititution admins won't see participants names, usernames, email address, or birthdates. If not provided, then it is considered as 0 by default.
 * @member {Number} isDeidentified
 */
CreateInstitutionParamsInstitution.prototype['isDeidentified'] = undefined;

/**
 * If set to 1, then all institution participants will automatically get upgraded from Lite to Pro. If not provided, then it is considered as 0 by default.
 * @member {Number} isEnablePro
 */
CreateInstitutionParamsInstitution.prototype['isEnablePro'] = undefined;

/**
 * If set to 1, then participants of this institution cannot belong to another institution. If not provided, then it is considered as 0 by default.
 * @member {Number} isExclusive
 */
CreateInstitutionParamsInstitution.prototype['isExclusive'] = undefined;

/**
 * Parameter is provided only if institution type is Trial, and it shows start date of the trial period.
 * @member {String} startDate
 */
CreateInstitutionParamsInstitution.prototype['startDate'] = undefined;

/**
 * Parameter is provided only if institution type is Trial, and it shows end date of the trial period.
 * @member {String} endDate
 */
CreateInstitutionParamsInstitution.prototype['endDate'] = undefined;

/**
 * List of all routing urls that can be used to get access to the institution
 * @member {Array.<String>} routingUrls
 */
CreateInstitutionParamsInstitution.prototype['routingUrls'] = undefined;

/**
 * ID of a secondary institution to be joined. The front-end joins this institution if the user does not provide consent to join the primary institution. This institution typically does not show a notification to the user when it is joined (skipWelcomeEmail is set to 0).
 * @member {Number} joinInstitutionIfNoConsent
 */
CreateInstitutionParamsInstitution.prototype['joinInstitutionIfNoConsent'] = undefined;

/**
 * If set to 1, new participants of this institution will not get welcome email. If not provided, then it is considered as 0 by default.
 * @member {Number} skipWelcomeEmail
 */
CreateInstitutionParamsInstitution.prototype['skipWelcomeEmail'] = undefined;

/**
 * If set to 1, all Pain Guide functionallity will be available for all participants.
 * @member {Number} painGuideAvailable
 */
CreateInstitutionParamsInstitution.prototype['painGuideAvailable'] = undefined;

/**
 * Institutions Ids of child institutions
 * @member {Array.<Number>} childInstitutionNids
 */
CreateInstitutionParamsInstitution.prototype['childInstitutionNids'] = undefined;

/**
 * Allowed values for the <code>type</code> property.
 * @enum {String}
 * @readonly
 */
CreateInstitutionParamsInstitution['TypeEnum'] = {
  /**
   * value: "Trial"
   * @const
   */
  "Trial": "Trial",
  /**
   * value: "Clinic"
   * @const
   */
  "Clinic": "Clinic",
  /**
   * value: "Study"
   * @const
   */
  "Study": "Study"
};
var _default = exports["default"] = CreateInstitutionParamsInstitution;